/**
 * A strip tile's trend (redesign §42.2, §29): 96 × 28 beside the figure (72 on
 * a phone), a teal stroke of 1.5, no axis. Decorative — `aria-hidden` — since
 * the figure and the sentence under it always say the same thing in words.
 */
import type React from 'react';
import { sparkGeometry } from '@airlock/contracts/usage/figures';
import { color } from '../theme/tokens';

export function Spark({ values }: { values: readonly (number | null)[] }): React.JSX.Element | null {
  const line = sparkGeometry(values);
  if (!line) return null;
  return (
    <svg
      className="al-spark"
      width={96}
      height={28}
      viewBox="0 0 160 36"
      preserveAspectRatio="none"
      aria-hidden
      style={{ flex: 'none', overflow: 'visible' }}
    >
      <polyline points={line.points} fill="none" stroke={color.accent} strokeWidth={1.5} vectorEffect="non-scaling-stroke" />
    </svg>
  );
}
